module.exports = __webpack_public_path__ + "static/media/search_person.adc6988b.svg";